import { createResponseSchema } from '@mint-sdk/api-core';
import { z } from 'zod';

export const UploadUrlsRequestItemSchema = z.object({
  filename: z.string(),
});

export const UploadUrlsRequestSchema = z
  .array(UploadUrlsRequestItemSchema)
  .min(1);

export const UploadUrlsItemSchema = z.object({
  assetId: z.string(),
  filename: z.string(),
  url: z.string(),
  key: z.string(),
  awsAccessKeyId: z.string(),
  'x-amz-security-token': z.string(),
  policy: z.string(),
  signature: z.string(),
  'Content-Type': z.string(),
});

export const UploadUrlsResponseSchema =
  createResponseSchema(UploadUrlsItemSchema);

export const ConfirmUploadItemSchema = z.object({
  url: z.string(),
  assetId: z.string(),
  filename: z.string(),
  width: z.number(),
  height: z.number(),
  filesize: z.number(),
  mimetype: z.string(),
  format: z.string(),
});

export const ConfirmUploadResponseSchema = createResponseSchema(
  ConfirmUploadItemSchema,
);

export const AssetsQuerySchema = z.object({
  settingsId: z.string(),
});

export const DefaultCreativesRequestItemSchema = z.object({
  activityFilterMappingId: z.string(),
  assetIds: z.array(z.string()),
});

export const DefaultCreativesRequestSchema = z.array(
  DefaultCreativesRequestItemSchema,
);

export const DefaultCreativeItemSchema = z.object({
  activityFilterMappingId: z.string(),
  campaignName: z.string(),
  width: z.number(),
  height: z.number(),
  assetId: z.string(),
  filename: z.string(),
  filesize: z.number(),
  format: z.string(),
  adExternalId: z.string(),
});

export const DefaultCreativesResponseSchema = createResponseSchema(
  DefaultCreativeItemSchema,
);
